import template from './auth.html';
import controller from './auth.controller';
import './auth.scss';

let authComponent = {
  bindings: {},
  template,
  controller
};

export default authComponent;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.component.js